import { useEffect } from "react";
import { db } from "@/lib/instantdb";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router";
import { fetchFinancialData, isDataStale } from "../stores/financial";
import {
  ApiUsageMetrics,
  FinancialMetrics,
  CostBreakdownChart,
  RevenueTrendChart,
} from "../components";

export default function GatewayDashboard() {
  const { user } = db.useAuth();

  // Fetch financial data on mount if stale
  useEffect(() => {
    if (isDataStale()) {
      fetchFinancialData();
    }
  }, []);

  return (
    <div className="flex h-full flex-col">
      {/* Fixed Header */}
      <header className="shrink-0 border-b bg-background px-4 py-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <h1 className="text-3xl font-bold">AI Gateway Dashboard</h1>
          <p className="mt-2 text-muted-foreground">
            Welcome back, {user?.email}
          </p>
        </div>
      </header>

      {/* Scrollable Content */}
      <main className="min-h-0 flex-1 overflow-y-auto">
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
          {/* API Stats */}
          <h2 className="text-lg font-semibold mb-4">API Usage</h2>
          <div className="mb-8">
            <ApiUsageMetrics />
          </div>

          {/* Financial Overview */}
          <h2 className="text-lg font-semibold mb-4">Financial Overview</h2>
          <div className="mb-8">
            <FinancialMetrics />
          </div>

          {/* Charts Grid */}
          <div className="grid gap-6 lg:grid-cols-2 mb-8">
            <CostBreakdownChart />
            <RevenueTrendChart />
          </div>

          {/* Quick Actions */}
          <div className="grid gap-6 md:grid-cols-2">
            <Card>
              <CardHeader>
                <CardTitle>Quick Actions</CardTitle>
                <CardDescription>
                  Common tasks you might want to do
                </CardDescription>
              </CardHeader>
              <CardContent className="flex flex-wrap gap-3">
                <Link to="/analytics">
                  <Button variant="outline">View Analytics</Button>
                </Link>
                <Button variant="outline">Create API Key</Button>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Supported Providers</CardTitle>
                <CardDescription>
                  AI services you can route through the proxy
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="flex flex-wrap gap-2">
                  {["OpenAI", "OpenRouter", "Anthropic", "ElevenLabs"].map(
                    (provider) => (
                      <span
                        key={provider}
                        className="inline-flex items-center rounded-full bg-primary/10 px-3 py-1 text-sm font-medium text-primary"
                      >
                        {provider}
                      </span>
                    ),
                  )}
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
    </div>
  );
}
